import { FORMAT_DEFINITIONS, PRODUCT_IMAGES } from './constants';
import { calculateFormatOutput } from './scenarioCalculations';
import { formatCurrency } from './formatters';

const FAMILY_LABELS = {
    rtd: 'Ready to Drink',
    concentrate: 'Concentrate',
};

const ScenarioSummaryPanel = ({
    activeProduct,
    selectedFamily,
    selectedFormatId,
    quantityValue,
    viewMode,
    canCreatePlan,
    blockedReason,
    onCreatePlan,
}) => {
    const normName = activeProduct?.product_name?.toLowerCase().trim();
    const productImg = normName ? PRODUCT_IMAGES[normName] : null;
    const format = FORMAT_DEFINITIONS[selectedFormatId];

    let estOutput = '—';
    let estRevenue = '—';
    let quantityDisplay = '—';

    if (format && quantityValue > 0) {
        if (viewMode === 'capacity') {
            const result = calculateFormatOutput(quantityValue, selectedFormatId);
            estOutput = `${Math.floor(result.units).toLocaleString()} ${format.unit}`;
            estRevenue = `${formatCurrency(result.wsRevenue)} / ${formatCurrency(result.retailRevenue)}`;
            quantityDisplay = `${quantityValue.toLocaleString(undefined, { maximumFractionDigits: 2 })} kegs`;
        } else {
            // eslint-disable-next-line no-unused-vars
            const kegsNeeded = quantityValue / format.per_concentrate_keg;
            estOutput = `${Math.floor(quantityValue).toLocaleString()} ${format.unit}`;
            estRevenue = `${formatCurrency(quantityValue * format.pricing.ws)} / ${formatCurrency(quantityValue * format.pricing.retail)}`;
            quantityDisplay = `${quantityValue.toLocaleString(undefined, { maximumFractionDigits: 2 })} ${format.unit}`;
        }
    }

    const summaryItems = [
        { label: 'Product', value: activeProduct?.product_name || '—' },
        { label: 'Family', value: FAMILY_LABELS[selectedFamily] || '—' },
        { label: 'Format', value: format?.name || '—' },
        { label: 'Quantity', value: quantityDisplay },
        { label: 'Est. Output', value: estOutput },
        { label: 'Est. Revenue', value: estRevenue },
    ];

    return (
        <aside className="gsp-summary-panel">
            {productImg && (
                <img
                    src={productImg}
                    alt=""
                    className="gsp-summary-bg-image"
                    aria-hidden="true"
                />
            )}
            <div className="gsp-summary-panel-header">SCENARIO SUMMARY</div>

            <div className="gsp-summary-items">
                {summaryItems.map(({ label, value }) => (
                    <div key={label} className="gsp-summary-item">
                        <span className="gsp-summary-label">{label}</span>
                        <strong className="gsp-summary-value">{value}</strong>
                    </div>
                ))}
            </div>

            <div className="gsp-summary-panel-footer">
                <button
                    className={`gsp-summary-create-btn ${canCreatePlan ? 'enabled' : ''}`}
                    disabled={!canCreatePlan}
                    onClick={onCreatePlan}
                    title={canCreatePlan ? 'Create production plan' : blockedReason}
                >
                    Create Production Plan
                </button>
                {!canCreatePlan && blockedReason && (
                    <p className="gsp-summary-btn-hint">{blockedReason}</p>
                )}
            </div>
        </aside>
    );
};

export default ScenarioSummaryPanel;
